import { render, staticRenderFns } from "./RenderPdf.vue?vue&type=template&id=2effe4fe&"
import script from "./RenderPdf.vue?vue&type=script&lang=js&"
export * from "./RenderPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports